import moment from "moment"

const defaultFormat = 'YYYY/MM/DD(ddd)'

export const formatDate = (date, format = defaultFormat) => {
  return moment(date).locale('ja').format(format)
}

export const formatTime = (saleDate) => {
  let time
  if (typeof saleDate == 'object') {
    time = saleDate.order_closing_date + ' ' + saleDate.order_closing_time
  } else if (typeof saleDate == 'string') {
    time = saleDate
  }
  return moment(time).format('HH:mm')
}